import vueVimeoPlayer from 'vue-vimeo-player';
import Vue from 'vue';
import axios from 'axios';

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

extend('required', required);
extend('email', email);

Vue.use(vueVimeoPlayer);

export default Vue.component('quiz', {
    components: {
        ValidationProvider, ValidationObserver
    },
    data: () => ({
        axe: axios.create({
            baseURL: '/wecyclecp/quiz'
        }),
        questionIndex: 0,
        userResponses: [],
        started: false,
        maxScore: 0,
        retrievingPostal: false,
        finished: false,
        videos: [],
        images: [],
        videoIndex: 0,
        videoPosition: 0,
        autoplayNotAllowed: false
    }),
    created() {
        this.videos = [
            ['460479318'],
            ['460479478'],
            ['460479471'],
            ['460479487'],
            ['460479367', '460479326'],
            ['460479185']
        ];

        // Init null variables with empty string to prevent issues with VeeValidate on android
        this.submission.name = "";
        this.submission.emailAddress = "";
        this.submission.postalCode = "";
    },
    mounted() {
        this.userResponses = Array(this.questions.length).fill(null);
        this.calculateMaxScore();
        this.preloadImages();

        if (this.isMobile) {
            this.autoplayNotAllowed = true;
        }
    },
    computed: {
        validPostal() {
            let regex = new RegExp(/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i);
            if (regex.test(this.submission.postalCode)) {
                return true;
            }
            return false;
        },
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        start() {
            this.started = true;
            this.getServicePoints();

            //video loading
            this.updateVideo(1);
            this.scrollToTop();
        },
        restart() {
            this.questionIndex = 0;
            this.userResponses = Array(this.questions.length).fill(null);

            //video loading
            this.updateVideo(1);
        },
        toggleOption(answer, index) {
            //check if responses contain index
            if (this.userResponses[this.questionIndex] === null) {
                this.userResponses[this.questionIndex] = [];
            }
            if (this.userResponses[this.questionIndex].indexOf(answer.text) !== -1) {
                //remove from responses
                var item = this.userResponses[this.questionIndex].indexOf(answer.text);
                if (item !== -1) {
                    this.userResponses[this.questionIndex].splice(item, 1);
                }
            } else {
                //add to responses
                let arr = this.userResponses[this.questionIndex];
                arr.push(answer.text);
                Vue.set(this.userResponses, this.questionIndex, arr);
            }
        },
        optionIsSelected(answer, index) {
            if (this.userResponses[this.questionIndex] !== null) {
                if (this.userResponses[this.questionIndex].indexOf(answer.text) !== -1) {
                    return true;
                }
            }
            return false;
        },
        questionAnswered(question) {
            if (question !== null) {
                if (question.length > 0) {
                    return true;
                }
            }
            return false;
        },
        next() {
            if (this.questionIndex < this.questions.length) {
                this.questionIndex++;

                // Last question was answered
                if (this.questionIndex == this.questions.length) { }
                else { }


                if (this.questionIndex >= this.questions.length && this.score() >= this.maxScore) {
                    //scoring page
                    this.updateVideo(this.videoIndex + 1, 1);

                } else {
                    this.updateVideo(this.videoIndex + 1);
                }
            }
            this.scrollToTop();
        },
        prev() {
            if (this.questionIndex > 0) {
                this.questionIndex--;

                //video loading
                this.updateVideo(this.videoIndex - 1);
            }
            this.scrollToTop();
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        preloadImages() {
            var i;
            for (i = 0; i < this.questions.length; i++) {
                let img = new Image();
                img.src =  `assets/wecycleCP/images/quiz/questions/question-${i + 1}.png`;
            }
        },
        score() {
            let score = 0;

            this.questions.forEach((q, i) => {
                this.questions[i].answers.forEach(answer => {
                    // Make sure there's a response
                    if (this.userResponses[i]) {
                        if (answer.isCorrect) {
                            // Answer should be correct. check in answers
                            if (this.userResponses[i].indexOf(answer.text) !== -1) {
                                score++;
                            }
                        } else {
                            // Answer should not be marked. check in answers
                            if (this.userResponses[i].indexOf(answer.text) === -1) {
                                score++;
                            }
                        }
                    } else {
                        // Means the answer is skipped > for reference
                    }
                })
            })
            
            // Add score to submission
            this.submission.score = score;

            return score;
        },
        updateVideo(newIndex, position = 0) {

            // Pause current video
            this.$refs.player.pause();
            // Update video
            this.videoPosition = position;

            this.videoIndex = newIndex;
        },
        playerLoaded() {
            //when player loaded, start playing video (also fires when video is updated)
            this.$refs.player.play();
        },
        playerEnded() {
            //when player ended, hide video (or do something else to hide vimeo related)
        },
        playerError(params) {
            if (params.name === 'NotAllowedError') {
                //user has not yet authorized website to play video's
                this.autoplayNotAllowed = true;
            }
        },
        playerPlay() {
            this.$refs.player.play();
            this.autoplayNotAllowed = false;
        },
        shuffle(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        },
        calculateMaxScore() {
            //maxScore is equal to the amount of questions
            this.maxScore = 0;
            this.questions.forEach((question) => {
                question.answers.forEach((answer) => {
                    this.maxScore++;
                });
            });
        },
        getServicePoints() {
            let response;
            this.retrievingPostal = true;
            this.axe.get("/GetServicePoints?address=" + this.submission.postalCode)
                .then((resp) => {
                    response = resp.data;

                    // Add answers to questions
                    if (response.length > 0) {
                        this.questions[2].answers = [];
                    }

                    response.forEach(servicePoint =>
                        this.questions[2].answers.push({
                            text: servicePoint.name,
                            isCorrect: true
                        })
                    );

                    // Shuffle answers
                    this.questions[2].answers = this.shuffle(this.questions[2].answers);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.calculateMaxScore();
                    this.retrievingPostal = false;
                });
        },
        onSubmit() {
            let response;
            this.axe.post("/SubmitResult", this.submission)
                .then((resp) => {
                    response = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.finished = true;
                    this.updateVideo(this.videoIndex + 1);
                    this.scrollToTop();
                });
        }
    },
    watch: {
        userResponses: function(newResponses, oldResponses) {
            this.submission.answers = newResponses.reduce((acc, val) => acc.concat(val), []).filter(Boolean).join('|');
        }
    }
});